export default "__VITE_ASSET__sKBbK8tv__"